import { Component } from '../core/Component';

/**
 * Position, rotation, and scale in 2D space.
 */
export class Transform extends Component {
  x: number = 0;
  y: number = 0;
  rotation: number = 0;
  scaleX: number = 1;
  scaleY: number = 1;
}
